/**
 * Z-Index Constants for Editor Components
 * 
 * This file centralizes all z-index values used throughout the editor
 * to maintain a clear layering hierarchy and prevent conflicts.
 * 
 * Hierarchy (lowest to highest):
 * - Base UI elements: 1-10
 * - Editor overlays: 11-99  
 * - Floating elements: 100-1000
 * - Modals and top-level UI: 1001-10000
 */

// Base UI elements (lowest level)
export const Z_INDEX = {
  // Base components
  BASE_TOOLTIP: 1,
  BOOST_DESIGN_BUTTON_VISIBLE: 1,
  BOOST_DESIGN_BUTTON_HIDDEN: -1,
  
  // Editor core components
  EDITOR_OVERLAY: 2,
  VIDEO_POPOVER_CONTENT: 2,
  BEFORE_AFTER_BUTTON: 3,
  SCENES: 4,
  EDIT_WITH_AI: 4,
  
  // Zoom and manipulation tools
  PIXEL_MANIPULATION_ZOOM: 10,
  MAIN_ZOOM_CONTROLS: 10,
  
  // Floating UI elements and overlays (1-100)
  GRADIENT_LOADER: 1,
  VIDEO_POPOVER_OVERLAY: 1,
  INSPECTOR_PANEL: 0,
  PARTICLES_ANIMATION: 1,
  
  // Medium priority UI (101-1000)
  TOOLTIP_CONFIRM: 100,
  IMAGE_PROCESSOR: 100,
  FACE_SWAPPER_GRID_BASE: 101,
  MAGIC_TOOL_BUTTON_HIGH: 110,
  
  // Editor overlays and content
  EDITOR_OVERLAY_CONTENT: 99,
  
  // Context menus and high priority UI
  CONTEXT_MENU: 1010,
  PANEL_POPOVER: 1000,
  CONTEXT_MENU_HIDDEN: -1,

  // Floating inspector and high-level UI
  INTENSITY_POPOVER: 1100,
  USER_MENU: 1100,
  FLOATING_INSPECTOR_POPOVER: 1008,
  TOOLTIP_MENU_TOOLTIP: 1007,
  TOOLTIP_MENU: 1006,
  DOWNLOAD_MODAL: 1006,
  FLOATING_INSPECTOR_ACTIVE: 1000,
  NAVBAR: 1004,
  BASE_POPOVER: 1003,
  ADD_MENU_ABOVE_INSPECTOR: 1002,
  INSPECTOR_MENU: 1001,
  ADD_MENU_BELOW_INSPECTOR: 1000,

  SUPPORT_BUTTON_HIGH: 9999, // Highest z-index for tall screens
  SUPPORT_BUTTON_LOW: 10, // Lowest z-index for short screens or when in state

  FLOATING_INSPECTOR_PIXEL_MANIPULATION_HIDDEN: -1,
  
  // Very high priority elements
  FACE_SWAPPER_GRID_HIGH: 999999,
  MODAL_TEMPLATE_HIGH: 10000,
  POPOVER_HIGH: 10000,
  
  // Top-level modals
  LOWER_MODAL: 9999,
  MODAL: 10000,
  MESSAGE_TOAST: 10001,
} as const

// Legacy constants for backward compatibility
export const EDITOR_OVERLAY_ZINDEX = Z_INDEX.EDITOR_OVERLAY
export const EDIT_WITH_AI_ZINDEX = Z_INDEX.EDIT_WITH_AI
export const MODAL_ZINDEX = Z_INDEX.MODAL
export const FLOATING_INSPECTOR_ZINDEX = Z_INDEX.FLOATING_INSPECTOR_ACTIVE